import React, { useState, useEffect } from "react";
import {
    Container,
    Card,
    Table,
    Pagination, Button, Modal
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getWithdrawalRequests, approveWithdrawal, rejectWithdrawal } from "../../store/slices/user";


export default function PendingFundRequest() {

    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const [rejectionReason, setRejectionReason] =
        useState("");
    const itemsPerPage = 20;
    const [showModal, setShowModal] =
        useState(false);

    const [showRejectBox, setShowRejectBox] =
        useState(false);

    const [selectedWithdraw, setSelectedWithdraw] =
        useState(null);

    const { withdrawalRequests, loading } = useSelector(
        (state) => state.user
    );
    useEffect(() => {
        const item = { status: "PENDING" }
        dispatch(getWithdrawalRequests(item));
    }, [dispatch]);

    const withdrawalData = withdrawalRequests || [];

    const totalPages = Math.ceil(
        withdrawalData.length / itemsPerPage
    );

    const currentData = withdrawalData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handleViewRequest = (
        withdraw
    ) => {
        setSelectedWithdraw(withdraw);
        setShowModal(true);
    };

    const handleApprove = async () => {

        const confirmed = window.confirm(
            "Are you sure you want to approve this withdrawal request?"
        );

        if (!confirmed) return;

        const result = await dispatch(
            approveWithdrawal({
                id: selectedWithdraw._id,
            })
        );

        if (
            approveWithdrawal.fulfilled.match(
                result
            )
        ) {
            alert(
                "Withdrawal approved successfully"
            );

            setShowModal(false);

            dispatch(
                getWithdrawalRequests({ status: "PENDING" })
            );
        }
    };


    const handleReject = async () => {

        if (!rejectionReason.trim()) {
            alert("Please enter rejection reason");
            return;
        }

        const result = await dispatch(
            rejectWithdrawal({
                id: selectedWithdraw._id,
                rejectionReason,
            })
        );

        if (
            rejectWithdrawal.fulfilled.match(result)
        ) {
            alert(
                "Withdrawal rejected successfully"
            );

            setShowModal(false);
            setShowRejectBox(false);
            setRejectionReason("");

            dispatch(
                getWithdrawalRequests()
            );
        }
    };

    return (

        <>
            <div className="breadcrumb-bar mx-1" >
                <div className="container-fluid">
                    <div className="d-flex  flex-row align-items-center justify-content-between gap-2 py-2">
                        <div className="breadcrumb-left d-flex align-items-center flex-wrap">
                            <Link to="/admin/home" className="breadcrumb-link active my-2">
                                Home
                            </Link>

                            <span className="breadcrumb-separator mx-2">
                                <i className="bi bi-chevron-right"></i>
                            </span>

                            <span
                                className="breadcrumb-link inactive"

                            >
                                Pending Fund Request
                            </span>

                        </div>


                    </div>
                </div>
            </div>



            <div className="ud-page-wrap">
                <Container fluid>

                    <div className="ud-header">
                        <h2 className="ud-main-title">Pending Fund Request</h2>

                    </div>

                    <Card className="ud-table-card">

                        <Card.Body className="p-0">

                            <div className="ud-scroll-wrap">

                                <Table
                                    hover
                                    borderless
                                    className="ud-table align-middle mb-0"
                                >

                                    <thead>

                                        <tr>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Withdraw Amount</th>
                                            <th>Bank</th>
                                            <th>Request Date</th>
                                            <th>Approval Date</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>

                                    </thead>

                                    <tbody>

                                        {currentData.map((withdraw, idx) => (

                                            <tr key={withdraw._id}>
                                                <td> {(currentPage - 1) * itemsPerPage + idx + 1}</td>

                                                <td>
                                                    <div className="ud-user-cell">
                                                        <span className="ud-user-name">{withdraw?.userId?.name}</span>
                                                    </div>
                                                </td>



                                                {/* <td>
                                                    <span className="ud-ref-badge">
                                                        ₹{withdraw.availableBalance}
                                                    </span>
                                                </td> */}

                                                <td>
                                                    <span className="ud-ref-badge">
                                                        ₹{withdraw.amount}
                                                    </span>
                                                </td>

                                                <td>{withdraw.bankAccountId?.bankName}</td>

                                                <td>
                                                    {withdraw?.createdAt
                                                        ? new Date(withdraw.createdAt).toLocaleDateString("en-IN")
                                                        : "-"}
                                                </td>

                                                <td>
                                                    {withdraw?.approvedAt
                                                        ? new Date(withdraw.approvedAt).toLocaleDateString("en-IN")
                                                        : "-"}
                                                </td>

                                                <td>
                                                    <span
                                                        className={`ud-ref-badge ${withdraw.status === "APPROVED"
                                                            ? "bg-success text-white "
                                                            : withdraw.status === "REJECTED"
                                                                ? "bg-danger text-white"
                                                                : "bg-warning text-white"
                                                            }`}
                                                    >
                                                        {withdraw.status}
                                                    </span>
                                                </td>

                                                <td className="d-flex justify-content-center align-items-center">
                                                    <button
                                                        className="global-login-btn px-2 py-1"
                                                        onClick={() =>
                                                            handleViewRequest(withdraw)
                                                        }
                                                    >
                                                        View Request Details
                                                    </button>
                                                </td>
                                            </tr>

                                        ))}

                                    </tbody>

                                </Table>

                            </div>

                        </Card.Body>

                    </Card>

                    {/* pagination */}

                    <div className="ud-pagination-wrap">
                        {totalPages > 1 && (
                            <div className="ud-pagination-wrap">
                                <Pagination className="ud-pagination mb-5">

                                    <Pagination.Prev
                                        disabled={currentPage === 1}
                                        onClick={() =>
                                            setCurrentPage((prev) => prev - 1)
                                        }
                                    />

                                    {[...Array(totalPages)].map((_, index) => (
                                        <Pagination.Item
                                            key={index + 1}
                                            active={currentPage === index + 1}
                                            onClick={() =>
                                                setCurrentPage(index + 1)
                                            }
                                        >
                                            {index + 1}
                                        </Pagination.Item>
                                    ))}

                                    <Pagination.Next
                                        disabled={currentPage === totalPages}
                                        onClick={() =>
                                            setCurrentPage((prev) => prev + 1)
                                        }
                                    />

                                </Pagination>
                            </div>
                        )}

                    </div>


                    <Modal
                        show={showModal}
                        onHide={() => setShowModal(false)}
                        centered
                        size="lg"
                    >
                        <Modal.Header
                            closeButton
                            className="border-0 pb-0"
                        >
                            <Modal.Title
                                className="fw-bold"
                            >
                                Withdrawal Request Details
                            </Modal.Title>
                        </Modal.Header>

                        <Modal.Body>

                            {selectedWithdraw && (

                                <>
                                    <div className="bg-light rounded-3 p-3 mb-4">

                                        <div className="d-flex justify-content-between align-items-center">

                                            <div>

                                                <h5 className="mb-1">
                                                    {selectedWithdraw?.userId?.name}
                                                </h5>

                                                <small className="text-muted">
                                                    Ref:
                                                    {" "}
                                                    {
                                                        selectedWithdraw?.userId?.referralCode
                                                    }
                                                </small>

                                            </div>

                                            <span
                                                className={`badge px-3 py-2 ${selectedWithdraw?.status === "Approved"
                                                    ? "bg-success"
                                                    : selectedWithdraw?.status === "Rejected"
                                                        ? "bg-danger"
                                                        : "bg-warning text-dark"
                                                    }`}
                                            >
                                                {selectedWithdraw?.status}
                                            </span>

                                        </div>

                                    </div>

                                    <div className="row g-3">

                                        <div className="col-md-6">
                                            <div className="border rounded p-3 h-100">
                                                <small className="text-muted">
                                                    Withdrawal Amount
                                                </small>

                                                <h4 className="mb-0 text-success">
                                                    ₹{selectedWithdraw?.amount}
                                                </h4>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="border rounded p-3 h-100">
                                                <small className="text-muted">
                                                    Request Date
                                                </small>

                                                <div>
                                                    {new Date(
                                                        selectedWithdraw?.createdAt
                                                    ).toLocaleString("en-IN")}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="border rounded p-3 h-100">
                                                <small className="text-muted">
                                                    Bank Name
                                                </small>

                                                <div className="fw-semibold">
                                                    {
                                                        selectedWithdraw?.bankAccountId?.bankName
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="border rounded p-3 h-100">
                                                <small className="text-muted">
                                                    Account Holder
                                                </small>

                                                <div className="fw-semibold">
                                                    {
                                                        selectedWithdraw?.bankAccountId?.accountHolderName
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="border rounded p-3 h-100">
                                                <small className="text-muted">
                                                    Account Number
                                                </small>

                                                <div className="fw-semibold">
                                                    {
                                                        selectedWithdraw?.bankAccountId?.accountNumber
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="border rounded p-3 h-100">
                                                <small className="text-muted">
                                                    IFSC Code
                                                </small>

                                                <div className="fw-semibold">
                                                    {
                                                        selectedWithdraw?.bankAccountId?.ifscCode
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        {showRejectBox && (
                                            <div className="col-12">
                                                <div className="border rounded p-3 bg-light">

                                                    <label className="fw-semibold mb-2">
                                                        Rejection Reason
                                                    </label>

                                                    <textarea
                                                        className="form-control"
                                                        rows="3"
                                                        placeholder="Enter rejection reason"
                                                        value={rejectionReason}
                                                        onChange={(e) =>
                                                            setRejectionReason(
                                                                e.target.value
                                                            )
                                                        }
                                                    />

                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}

                        </Modal.Body>
                        <Modal.Footer>




                            {selectedWithdraw?.status === "PENDING" && (
                                <>
                                    {!showRejectBox ? (
                                        <>
                                            <Button
                                                variant="danger"
                                                onClick={() =>
                                                    setShowRejectBox(true)
                                                }
                                            >
                                                <i className="bi bi-x-circle me-2"></i>
                                                Reject
                                            </Button>

                                            <Button
                                                variant="success"
                                                onClick={handleApprove}
                                                disabled={loading}
                                            >
                                                <i className="bi bi-check-circle me-2"></i>
                                                Approve
                                            </Button>
                                        </>
                                    ) : (
                                        <>
                                            <Button
                                                variant="outline-secondary"
                                                onClick={() => {
                                                    setShowRejectBox(false);
                                                    setRejectionReason("");
                                                }}
                                            >
                                                Cancel
                                            </Button>

                                            <Button
                                                variant="danger"
                                                onClick={handleReject}
                                                disabled={loading}
                                            >
                                                Confirm Reject
                                            </Button>
                                        </>
                                    )}
                                </>
                            )}

                        </Modal.Footer>
                    </Modal>

                </Container>

            </div>
        </>

    );
}